// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__VysOm","title":"AfterBackImages_title__KEE4U","images":"AfterBackImages_images__24Buq"};